import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { billingRunsMessages } from 'src/features/billingRuns/utils/messages';
import { BILLING_RUN_STATUS, BILLING_RUN_TYPE } from 'src/features/billingRuns/utils/types';

export const BILLING_RUN_TYPE_MAP: Record<BILLING_RUN_TYPE, { id: string; defaultMessage: string }> = {
    [BILLING_RUN_TYPE.CHARGING]: billingRunsMessages.charging,
    [BILLING_RUN_TYPE.INVOICING]: billingRunsMessages.invoicing,
};

export const BILLING_RUN_TYPE_BADGE_OPTIONS: Record<BILLING_RUN_TYPE, BadgeOption> = {
    [BILLING_RUN_TYPE.CHARGING]: {
        label: billingRunsMessages.charging,
        theme: 'indigo',
        icon: ICON_MAP.WAVE_PULSE,
    },
    [BILLING_RUN_TYPE.INVOICING]: {
        label: billingRunsMessages.invoicing,
        theme: 'cyan',
        icon: ICON_MAP.INVOICE,
    },
};

export const BILLING_RUN_STATUS_BADGE_OPTIONS: Record<BILLING_RUN_STATUS, BadgeOption> = {
    [BILLING_RUN_STATUS.RUNNING]: {
        label: billingRunsMessages.running,
        theme: 'blue',
        icon: ICON_MAP.SPINNER,
    },
    [BILLING_RUN_STATUS.COMPLETED]: {
        label: billingRunsMessages.completed,
        theme: 'green',
        icon: ICON_MAP.CHECK,
    },
    [BILLING_RUN_STATUS.FAILED]: {
        label: billingRunsMessages.failed,
        theme: 'red',
        icon: ICON_MAP.X_MARK,
    },
};
